import originalApi from '@lib/api';
import { UNIVERSAL_ADMIN } from '@lib/tools/helpers/constants';
import axios from 'axios';

const api = {
  async sendForm(data) {
    const response = await axios.post(`${UNIVERSAL_ADMIN}/forms`, data);
    return response.data;
  },

  async logResponseGTM({ event, eventCategory, eventAction, eventLabel }) {
    window.dataLayer.push({
      event: event,
      eventCategory: eventCategory,
      eventAction: eventAction,
      eventLabel: eventLabel,
    });
    return Promise.resolve();
  },
  async logDataToServer(data) {
    const response = await axios.post(originalApi.otherInformation, data);
    return response.data;
  },
};

export { api };
